(function() {
  const chatLinks = document.querySelectorAll('.contactUs__listLinkChat');

  function openChat() {
    const chatButton = document.querySelector('#chat-button');

    if (chatButton) {
      chatButton.contentWindow.document.querySelector("button").click();
    }
  }

  chatLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      openChat();
    });
  });
})();
